export default __webpack_public_path__ + "static/media/logo.1a289f61.svg";